// import React from "react";
// import { CardBody, Table, Label, Input } from "reactstrap";

// import MyPagination from "./pagination";
// import { useCurrency } from "../_helper/currencyContext";
// import { useLab } from "../_helper/PharmacyProvider";
// import { Tooltip } from "react-tooltip";
// import { FormLabel } from "react-bootstrap";
// import { useTranslation } from "react-i18next";

// export default function CommonTable({
//     columns = [],
//     data = [],
//     onToggleStatus,
//     onAction = [],
//     totalPages,
//     currentPage,
//     setCurrentPage,
//     entriesPerPage,
//     setEntriesPerPage
// }) {
//     const { getCurrencySymbol } = useCurrency();
//     const { currentLab } = useLab();
//     const { t } = useTranslation()
//     // Get currency symbol from context (fallback to ₹)
//     const currencySymbol = getCurrencySymbol(currentLab?.baseCurrency);

//     const handlePageSizeChange = (e) => {
//         const newSize = Number(e.target.value);
//         setEntriesPerPage(newSize);  // Use the correct setter
//         setCurrentPage(1);           // Reset to page 1
//     }
//     const getStartingSerialNumber = () => {
//         return (currentPage - 1) * entriesPerPage + 1;
//     };
//     return (
//         <CardBody className="tw-px-0">
//             <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black">
//                 <Table className="mb-0 table-center table-bordered table-hover"  style={{ tableLayout: "fixed",overflowX:'auto' }}>
//                     <thead>
//                         <tr>
//                             <th className="text-center bg-primary" style={{
//                                 width:  "80px"   // 👈 add width only to first column
//                             }}>
//                                 <b>#</b>
//                             </th>
//                             {columns.map((col, index) => (
//                                 <th key={index} style={{ whiteSpace: "nowrap" , width: col.width}} className="bg-primary" >
//                                     <b>{col.header}</b>
//                                 </th>
//                             ))}
//                             {onToggleStatus && (
//                                 <th className="text-center bg-primary" style={{ whiteSpace: "nowrap", width:'100px' }}>
//                                     <b>Status</b>
//                                 </th>
//                             )}
//                             {onAction.length > 0 && (
//                                 <th className="text-center bg-primary" style={{ whiteSpace: "nowrap",width:'150px' }}>
//                                     <b>Action</b>
//                                 </th>
//                             )}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {data.length > 0 ? (
//                             data.map((row, rowIndex) => {
//                                 const serialNumber = getStartingSerialNumber() + rowIndex;
//                                 return (
//                                     <tr key={rowIndex}>
//                                         <td className="text-center font-weight-bold">
//                                             {serialNumber}
//                                         </td>
//                                         {columns.map((col, colIndex) => {
//                                             const value = row[col.accessor];
//                                             const isCostColumn = col.header.toLowerCase().includes("cost") ||
//                                                 col.accessor.toLowerCase().includes("cost") ||
//                                                 col.accessor.toLowerCase().includes("price");

//                                             return (
//                                                 <td
//                                                     key={colIndex}
//                                                     style={{
//                                                         paddingLeft: colIndex === 0 ? "1rem" : "0.5rem",
//                                                     }}
//                                                 >
//                                                     {col.render ? (
//                                                         col.render(value, row)
//                                                     ) : isCostColumn ? (
//                                                         <strong>
//                                                             {currencySymbol}{' '}
//                                                             {Number(value).toLocaleString(undefined, {
//                                                                 minimumFractionDigits: 2,
//                                                                 maximumFractionDigits: 2,
//                                                             })}
//                                                         </strong>
//                                                     ) : (
//                                                         value
//                                                     )}
//                                                 </td>
//                                             );
//                                         })}

//                                         {/* Status Toggle */}
//                                         {onToggleStatus && (
//                                             <td className="text-center">
//                                                 <Label className="switch">
//                                                     <Input
//                                                         type="checkbox"
//                                                         checked={row.isActive === true}
//                                                         onChange={() => onToggleStatus(row)}
//                                                     />
//                                                     <span className="switch-state"></span>
//                                                 </Label>
//                                             </td>
//                                         )}

//                                         {/* Actions */}
//                                         {onAction?.length > 0 && (
//                                             <td className="tw-text-center">
//                                                 <div className="tw-flex tw-justify-center tw-items-center  tw-whitespace-nowrap">
//                                                     {onAction.map((action, index) => (
//                                                         <div
//                                                             key={index}
//                                                             onClick={() => action.onClick(row)}
//                                                             className="tw-cursor-pointer tw-hover:bg-gray-100 tw-rounded tw-transition-colors"
//                                                             title={action.label}
//                                                         >

//                                                             {action.label === "View" && (
//                                                                 <>

//                                                                     <Tooltip id="view" place="top" content="View" />
//                                                                     <button className='success-action-button me-1' data-tooltip-id="view" >
//                                                                         <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
//                                                                     </button>
//                                                                 </>
//                                                             )}
//                                                             {action.label === "Edit" && (
//                                                                 <>
//                                                                     <Tooltip id="edit" place="top" content="Edit" />
//                                                                     <button className='success-action-button me-1' data-tooltip-id="edit">
//                                                                         <i className="fa fa-pencil-square" style={{ fontSize: "18px" }}></i>
//                                                                     </button>
//                                                                 </>
//                                                             )}
//                                                             {action.label === "Delete" && (
//                                                                 <>
//                                                                     <Tooltip id="delete" place="top" content="Delete" />
//                                                                     <button className='danger-action-button me-1' data-tooltip-id="delete">
//                                                                         <i className="fa fa-trash tw-text-red-600" style={{ fontSize: "18px" }}></i>
//                                                                     </button>
//                                                                 </>
//                                                             )}
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </td>
//                                         )}
//                                     </tr>
//                                 )
//                             })
//                         ) : (
//                             <tr>
//                                 <td
//                                     colSpan={
//                                         columns.length +
//                                         (onToggleStatus ? 1 : 0) +
//                                         (onAction.length > 0 ? 1 : 0) +1
//                                     }
//                                     className="text-center py-4 text-muted"
//                                 >
//                                     No data available
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </Table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//                 <div className="d-md-flex align-items-center text-center justify-content-between mt-3">
//                     <div className="show-entries">
//                         <FormLabel>{t("Show")}&nbsp;</FormLabel>
//                         <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
//                             onChange={handlePageSizeChange} className="form-control">
//                             <option value={5}>5</option>
//                             <option value={10}>10</option>
//                             <option value={30}>30</option>
//                             <option value={20}>20</option>
//                             <option value={50}>50</option>
//                         </select>&nbsp;
//                         <FormLabel>{t("entries")}</FormLabel>
//                     </div>
//                     <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage} />
//                 </div>
//             )}
//         </CardBody>
//     );
// }

import React from "react";
import { CardBody, Table, Label, Input } from "reactstrap";

import MyPagination from "./pagination";
import { useCurrency } from "../_helper/currencyContext";
import { useLab } from "../_helper/PharmacyProvider";
import { Tooltip } from "react-tooltip";
import { FormLabel } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function CommonTable({
    columns = [],
    data = [],
    onToggleStatus,
    onAction = [],
    totalPages,
    currentPage,
    setCurrentPage,
    entriesPerPage,
    setEntriesPerPage
}) {
    const { getCurrencySymbol } = useCurrency();
    const { currentLab } = useLab();
    const { t } = useTranslation();

    const currencySymbol = getCurrencySymbol(currentLab?.baseCurrency);

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);
        setCurrentPage(1);
    };

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    // Helper to safely display value or fallback to "-"
    const displayValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return "-";
        }
        return value;
    };

    return (
        <CardBody className="tw-px-0">
            <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black">
                <Table className="mb-0 table-center table-bordered table-hover" style={{ tableLayout: "fixed", overflowX: 'auto' }}>
                    <thead>
                        <tr>
                            <th className="text-center bg-primary" style={{ width: "40px" }}>
                                <b>#</b>
                            </th>
                            {columns.map((col, index) => (
                                <th key={index} style={{ width: col.width }} className="bg-primary">
                                    <b>{col.header}</b>
                                </th>
                            ))}
                            {onToggleStatus && (
                                <th className="text-center bg-primary" style={{ whiteSpace: "nowrap", width: '100px' }}>
                                    <b>Status</b>
                                </th>
                            )}
                            {onAction.length > 0 && (
                                <th className="text-center bg-primary" style={{ whiteSpace: "nowrap", width: '150px' }}>
                                    <b>Action</b>
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, rowIndex) => {
                                const serialNumber = getStartingSerialNumber() + rowIndex;
                                return (
                                    <tr key={rowIndex}>
                                        <td className="text-center font-weight-bold">
                                            {serialNumber}
                                        </td>
                                        {columns.map((col, colIndex) => {
                                            const rawValue = row[col.accessor];
                                            const isCostColumn = col.header.toLowerCase().includes("cost") ||
                                                col.accessor.toLowerCase().includes("cost") ||
                                                col.accessor.toLowerCase().includes("price");

                                            let displayContent;

                                            if (col.render) {
                                                // If custom render is provided, use it (it should handle empty values itself)
                                                displayContent = col.render(rawValue, row);
                                            } else if (isCostColumn) {
                                                // Format price, but show "-" if no valid number
                                                const numValue = Number(rawValue);
                                                displayContent = !isNaN(numValue) && rawValue != null
                                                    ? <strong>
                                                        {currencySymbol}{' '}
                                                        {numValue.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                      </strong>
                                                    : "-";
                                            } else {
                                                // Default: show value or "-"
                                                displayContent = displayValue(rawValue);
                                            }

                                            return (
                                                <td
                                                    key={colIndex}
                                                    style={{
                                                        paddingLeft: colIndex === 0 ? "1rem" : "0.5rem",
                                                    }}
                                                >
                                                    {displayContent}
                                                </td>
                                            );
                                        })}

                                        {/* Status Toggle */}
                                        {onToggleStatus && (
                                            <td className="text-center">
                                                <Label className="switch">
                                                    <Input
                                                        type="checkbox"
                                                        checked={row.isActive === true}
                                                        onChange={() => onToggleStatus(row)}
                                                    />
                                                    <span className="switch-state"></span>
                                                </Label>
                                            </td>
                                        )}

                                        {/* Actions */}
                                        {onAction?.length > 0 && (
                                            <td className="tw-text-center">
                                                <div className="tw-flex tw-justify-center tw-items-center tw-whitespace-nowrap">
                                                    {onAction.map((action, index) => (
                                                        <div
                                                            key={index}
                                                            onClick={() => action.onClick(row)}
                                                            className="tw-cursor-pointer tw-hover:bg-gray-100 tw-rounded tw-transition-colors"
                                                            title={action.label}
                                                        >
                                                            {action.label === "View" && (
                                                                <>
                                                                    <Tooltip id="view" place="top" content="View" />
                                                                    <button className='success-action-button me-1' data-tooltip-id="view">
                                                                        <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                            {action.label === "Edit" && (
                                                                <>
                                                                    <Tooltip id="edit" place="top" content="Edit" />
                                                                    <button className='success-action-button me-1' data-tooltip-id="edit">
                                                                        <i className="fa fa-pencil-square" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                            {action.label === "Delete" && (
                                                                <>
                                                                    <Tooltip id="delete" place="top" content="Delete" />
                                                                    <button className='danger-action-button me-1' data-tooltip-id="delete">
                                                                        <i className="fa fa-trash tw-text-red-600" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td
                                    colSpan={
                                        columns.length +
                                        (onToggleStatus ? 1 : 0) +
                                        (onAction.length > 0 ? 1 : 0) +
                                        1 // +1 for serial number column
                                    }
                                    className="text-center py-4 text-muted"
                                >
                                    {t("No data available")}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="d-md-flex align-items-center text-center justify-content-between mt-3">
                    <div className="show-entries">
                        <FormLabel>{t("Show")}&nbsp;</FormLabel>
                        <select
                            style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }}
                            value={entriesPerPage}
                            onChange={handlePageSizeChange}
                            className="form-control"
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>&nbsp;
                        <FormLabel>{t("entries")}</FormLabel>
                    </div>
                    <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage} />
                </div>
            )}
        </CardBody>
    );
}